<div class="warehouse" *ngIf="params?.Status !== 'DRAFT' || isWalmart">
    <div class="warehouse_shipFrom"
      [matTooltip]="
      params?.FromWAddressLine1 +
        ' ' +
        params?.FromWCity +
        ' ' +
        params?.FromWState +
        ' ' +
        params?.FromWCounty
      "
    >
      {{ ( params?.FromWCode?.length > 8) ? (params?.FromWCode | slice : 0:8) + '...' : ( params?.FromWCode) }}
    </div>
    <i class="fal fa-chevron-double-right"></i>
    <div
      [matTooltip]="
        params?.ToWAddressLine1 +
        ' ' +
        params?.ToWCity +
        ' ' +
        params?.ToWState +
        ' ' +
        params?.ToWCountry
      "
    >
      {{ params?.DestinationWCode }}
    </div>
  </div>